import React from 'react';

import { checkingAccountProductsQuery } from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getCheckingAccountFilters, tableHead } from './constants';
import ProductItem from './item';

export const CheckingAccountTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={checkingAccountProductsQuery}
      productsFiltersGetter={getCheckingAccountFilters}
      tableHeadItems={tableHead}
      tabletColumns={4}
      mobileFields={[
        { key: 'customerNameNormalized', label: 'Cliente' },
        { key: 'advisorNameNormalized', label: 'Assessor' },
        { key: 'availableValueNormalized', label: 'Valor disponível' },
        { key: 'totalValueNormalized', label: 'Valor total' },
      ]}
    />
  );
};
